import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { endpoints } from '../../endpoints';

@Injectable({ providedIn: 'root' })
export class NsideIdentityService {
  private apiToken: string | null = null;
  private tokenExpiry = 0;

  constructor(private http: HttpClient) {}

  getUser() {
    const url = environment.identityUrl + '/verify-session';
    return this.http
      .post<any>(url, {}, { withCredentials: true })
      .pipe(
        map((res) => res.claims),
        catchError(() => of(null))
      );
  }

  isAuthenticated() {
    return this.getUser().pipe(
      map((user) => !!user)
    );
  }

  fetchApiToken(): Observable<string | null> {
    const url = environment.identityUrl + endpoints.getApiToken;
    return this.http
      .post<any>(url, {}, { withCredentials: true })
      .pipe(
        map((res) => {
          if (res.success && res.api_token) {
            this.apiToken = res.api_token;
            this.tokenExpiry = Date.now() + ((res.expires_in - 60) * 1000);
            return this.apiToken;
          }
          return null;
        }),
        catchError(() => of(null))
      );
  }

  getToken(): string | null {
    if (this.apiToken && Date.now() < this.tokenExpiry) {
      return this.apiToken;
    }
    return null;
  }

  isTokenValid(): boolean {
    return !!this.getToken();
  }

  clearToken(): void {
    this.apiToken = null;
    this.tokenExpiry = 0;
  }

  logout(): void {
    this.clearToken();
    window.location.href = environment.identityUrl + endpoints.logout;
  }
}
